import { render, staticRenderFns } from "./ArtworkCreateModal.vue?vue&type=template&id=d0070470&scoped=true"
import script from "./ArtworkCreateModal.vue?vue&type=script&lang=js"
export * from "./ArtworkCreateModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkCreateModal.vue?vue&type=style&index=0&id=d0070470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0070470",
  null
  
)

export default component.exports